export default __webpack_public_path__ + "static/media/IMG_1715.21e46526.jpg";